var React = require('react');

function IconMinusSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M940.667 46.673H90.303c-6.683 0-12.151 5.468-12.151 12.151v850.364c0 6.683 5.468 12.151 12.151 12.151h850.364c1.671 0 3.266-.342 4.718-.959a12.252 12.252 0 0 0 4.649-3.475 12.088 12.088 0 0 0 2.784-7.718V58.824c0-6.683-5.468-12.151-12.151-12.151zm-795.28 79.386c0-6.683 5.468-12.151 12.151-12.151h715.894c6.683 0 12.151 5.468 12.151 12.151v715.894c0 3.341-1.367 6.379-3.569 8.582s-5.24 3.569-8.582 3.569H157.538c-6.683 0-12.151-5.468-12.151-12.151V126.059z","key":0}),React.createElement("path",{"d":"M790.68 451.679H240.29c-5.445 0-9.901 4.455-9.901 9.901v44.851c0 5.445 4.455 9.901 9.901 9.901h550.39c5.446 0 9.901-4.455 9.901-9.901V461.58c0-5.445-4.455-9.901-9.901-9.901z","key":1})]);
}

IconMinusSquare.displayName = "IconMinusSquare";

IconMinusSquare.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconMinusSquare;

IconMinusSquare.default = IconMinusSquare;
